module.exports = __webpack_public_path__ + "img/gallery-6.8a0a173b.png";